import React, { useState } from 'react';
import { UnlockDialog } from '@apps/guest/packages/layout-engine/components/UnlockDialog/UnlockDialog';
import { useDisclosure } from '@withjoy/joykit';
import { UnlockDialogContext } from './UnlockDialog.context';

export const UnlockDialogProvider: React.FC = ({ children }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [shouldDisplayFindInvite, setShouldDisplayFindInvite] = useState<boolean>(false);
  const [shouldSkipPasswordGate, setShouldSkipPasswordGate] = useState<boolean>(false);

  const handleUnlockDialogOpen = (displayFindInvite?: boolean, skipPasswordGate?: boolean) => {
    setShouldDisplayFindInvite(displayFindInvite ?? false);
    setShouldSkipPasswordGate(skipPasswordGate ?? false);
    onOpen();
  };

  return (
    <UnlockDialogContext.Provider value={{ isOpen, handleUnlockDialogOpen, onClose, shouldDisplayFindInvite }}>
      {children}
      <UnlockDialog
        isOpen={isOpen}
        handleUnlockDialogOpen={handleUnlockDialogOpen}
        onClose={onClose}
        shouldDisplayFindInvite={shouldDisplayFindInvite}
        shouldSkipPasswordGate={shouldSkipPasswordGate}
      />
    </UnlockDialogContext.Provider>
  );
};

export { UnlockDialogContext, useUnlockDialogContext } from './UnlockDialog.context';
export type { UnlockDialogContextValue } from './UnlockDialog.context';
